import React from "react";
import { LawsuitInfo } from "@customTypes/responses/lawsuit";
import { InfoCard, CardDivider, NormalText } from "@components/styles/dataDisplay";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import LawsuitDataTabSkeleton from "../../skeletons/LawsuitDataTabSketon";
import { LabeledRow } from "@components/LabeledRow";
import { CustomToggletip, InfoContainer } from "../style";
import { InvolvedPeople } from "../components/InvolvedPeople";
import { useQuery } from "react-query";
import { LawsuitAttachments } from "../components/LawsuitAttachment";

const isLawsuit = (lawsuit: LawsuitInfo) => {
  return lawsuit.type === "CTE_LAWSUIT";
};

type LawsuitDataTabProps = {
  lawsuitId: string;
};

const toggleTipMessage = "O valor da condenação é aquele definido na sentença do processo.";

const LawsuitDataTab: React.FC<LawsuitDataTabProps> = ({ lawsuitId }) => {
  const { isLoading, data: lawsuit } = useQuery<LawsuitInfo>(["getCase", lawsuitId]);

  if (isLoading || !lawsuit) return <LawsuitDataTabSkeleton />;

  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin size="sm">
            {`Dados do ${lawsuit?.type === "CTE_CASE" ? "caso" : "processo"}`}
          </CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            {`Veja todas as informações do seu ${
              lawsuit?.type === "CTE_CASE" ? "caso" : "processo"
            } de forma detalhada.`}
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      <InfoCard spacing="lg" border>
        {isLawsuit(lawsuit) && (
          <InfoContainer key="lawsuit-container">
            <LabeledRow label="Ação" value={lawsuit.actionType} />
            <LabeledRow label="Número do processo" value={lawsuit.numberCase} />
            <LabeledRow label="Objeto" value={lawsuit.description} isHtml />
            <LabeledRow label="Observações" value={lawsuit.observation} isHtml />
            <LabeledRow label="Juízo" value={lawsuit.courtInfo} />
            <LabeledRow label="Foro" value={lawsuit.court} />
            <LabeledRow
              label="Valor da condenação"
              value={lawsuit.convictionAmount ? `R$ ${lawsuit.convictionAmount}` : ""}
              labelIcon={
                <CustomToggletip
                  title="Valor da condenação"
                  message={<NormalText>{toggleTipMessage}</NormalText>}
                  icon="fa-question-circle-o"
                  position="right"
                />
              }
            />
            <CardDivider />
          </InfoContainer>
        )}
        {!isLawsuit(lawsuit) && (
          <InfoContainer key="case-container">
            <LabeledRow label="Descrição" value={lawsuit.description} />
            <LabeledRow label="Observações" value={lawsuit.observation} />
            <CardDivider />
          </InfoContainer>
        )}
        <InvolvedPeople customers={lawsuit?.customers} stakeholders={lawsuit?.stakeholder} />
        <LawsuitAttachments attachments={lawsuit?.attachments} lawsuitId={lawsuit.id} />
      </InfoCard>
    </div>
  );
};

export default LawsuitDataTab;
